import React from 'react';

import { graphql } from 'gatsby';

import { Language, Market, PageType } from '@mewa/types';

import { CampaignHeader } from '../../../components/header/campaign-header';
import { Header } from '../../../components/header/header';
import { MinimalHeader } from '../../../components/header/minimal-header';
import { NavigationData } from '../../../components/header/types';
import { HeaderCampaign, isHeaderCampaign } from './header-campaign';
import { HeaderDefault, isHeaderDefault } from './header-default';
import { HeaderMinimal, isHeaderMinimal } from './header-minimal';

export const StrapiCampaignHeaderSectionFragment = graphql`
  fragment CampaignHeaderSectionFragment on STRAPI_CAMPAIGN_PAGE {
    header {
      ...HeaderDefaultFragment
      ...HeaderMinimalFragment
      ...HeaderCampaignFragment
    }
  }
`;
export type PossibleHeaderComponents =
  | HeaderCampaign
  | HeaderDefault
  | HeaderMinimal
  | { strapi_component: '' };

type StrapiHeaderSectionProps = {
  lang: Language;
  langPrefix: string;
  market: Market;
  locale: string;
  locationKey: string;
  navigationData: NavigationData;
  locationSearch: string;
  showCTA: boolean;
  header: PossibleHeaderComponents[];
};

export const StrapiHeaderSection = React.memo(
  ({
    lang,
    langPrefix,
    market,
    locale,
    navigationData,
    locationKey,
    locationSearch,
    showCTA,
    header,
  }: StrapiHeaderSectionProps) => {
    return header.map((component, idx) => {
      if (isHeaderCampaign(component)) {
        return (
          <CampaignHeader
            key={idx}
            langPrefix={langPrefix}
            navigationData={navigationData}
            market={market}
            ctaUrl={component.ctaUrl}
            ctaLabel={component.ctaLabel}
            piwikEventName={component.piwikEventName}
            showCTA={showCTA}
            headerText={component.headerText ?? undefined}
          />
        );
      } else if (isHeaderDefault(component)) {
        return (
          <Header
            key={idx}
            langPrefix={langPrefix}
            navigationData={navigationData}
            locationKey={locationKey ?? ''}
            market={market}
            lang={lang}
            locale={locale}
            locationSearch={locationSearch}
            showCTA={showCTA}
            pageType={PageType.campaign}
          />
        );
      } else if (isHeaderMinimal(component)) {
        return <MinimalHeader key={idx} langPrefix={langPrefix} />;
      }
      return null;
    });
  },
);
